// extracted by mini-css-extract-plugin
export default {"page":"LY-z","cartModal":"MY-z","checkout":"NY-z","placeholder":"OY-z","account":"PY-z"};